export default "__VITE_ASSET__BuPavqlO__"